import { render, staticRenderFns } from "./big-code.vue?vue&type=template&id=4c2e2925&scoped=true"
import script from "./big-code.vue?vue&type=script&lang=js"
export * from "./big-code.vue?vue&type=script&lang=js"
import style0 from "./big-code.vue?vue&type=style&index=0&id=4c2e2925&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e2925",
  null
  
)

export default component.exports